import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-table-paginator',
  templateUrl: './table-paginator.component.html',
  styleUrl: './table-paginator.component.scss'
})
export class TablePaginatorComponent {
  @Input() totalItems = 0; // Total de itens
  @Input() pageSize = 10; // Quantidade de itens por página
  @Input() currentPage = 1; // Página atual
  @Input() totalPages;
  @Output() pageChange = new EventEmitter<number>(); // Emissor de evento para mudanças de página

  //totalPages = 0;
  pages: number[] = [];

  ngOnChanges() {
    this.totalPages = Math.ceil(this.totalItems / this.pageSize);
    this.generatePages();
  }

  generatePages() {
    const maxPagesToShow = 5; // Máximo de páginas visíveis
    let startPage: number;
    let endPage: number;
  
    if (this.totalPages <= maxPagesToShow) {
      // Se o total de páginas é menor ou igual ao número máximo, mostra todas as páginas
      startPage = 1;
      endPage = this.totalPages;
    } else if (this.currentPage <= Math.floor(maxPagesToShow / 2)) {
      // Se a página atual está entre as primeiras 3 (em 5 páginas visíveis)
      startPage = 1;
      endPage = maxPagesToShow;
    } else if (this.currentPage + Math.floor(maxPagesToShow / 2) >= this.totalPages) {
      // Se a página atual está nas últimas páginas
      endPage = this.totalPages;
      startPage = this.totalPages - maxPagesToShow + 1;
    } else {
      // Caso geral: centraliza a página atual
      startPage = this.currentPage - Math.floor(maxPagesToShow / 2);
      endPage = startPage + maxPagesToShow - 1;
    }
  
    // Gera o array de páginas
    this.pages = [];
    for (let i = startPage; i <= endPage; i++) {
      this.pages.push(i);
    }
  }
  
  

  setPage(page: number) {
    if (page < 1 || page > this.totalPages || page === this.currentPage) {
      return;
    }
    this.currentPage = page;
    this.generatePages(); // Recalcula as páginas visíveis imediatamente
    this.pageChange.emit(this.currentPage);
  }
  
  
}
